import React from "react";

function Donate() {
  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/page-title-donate.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Donate</h1>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Donate</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Donation Info Section */}
      <section>
        <div className="container">
          <div
            className="mb-1-6 mb-lg-5 image-hover wow fadeInUp"
            data-wow-delay="100ms"
          >
            <img
              src="img/portfolio/donate-1.jpg"
              alt="..."
              className="border-radius-10"
            />
          </div>
          <div className="row justify-content-between mt-n1-9">
            <div className="col-lg-4 col-xl-3 mt-1-9 wow fadeInUp" data-wow-delay="100ms">
              <div className="border border-radius-10">
                <img
                  src="img/team/donate-01.jpg"
                  alt="Donation Account"
                  className="border-radius-top"
                />
                <div className="p-1-9 p-xl-2-6">
                  <div className="mb-4 border-bottom pb-4">
                    <h2 className="mb-0 font-weight-600 lh-1 h4">
                      Donation Account's Details:
                    </h2>
                  </div>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-4 text-dark font-weight-600">
                      <span className="d-block text-primary lh-1">Bank Name:</span>
                      <span className="text-dark">Punjab National Bank</span>
                    </li>
                    <li className="mb-4 text-dark font-weight-600">
                      <span className="d-block text-primary lh-1">Branch:</span>
                      <span className="text-dark">Amarkanan</span>
                    </li>
                    <li className="mb-4 text-dark font-weight-600">
                      <span className="d-block text-primary lh-1">IFS Code:</span>
                      <span className="text-dark">PUNB0019520</span>
                    </li>
                    <li className="mb-4 text-dark font-weight-600">
                      <span className="d-block text-primary lh-1">A/C NAME:</span>
                      <span className="text-dark">SHAMAYITA MATH PROG. FUND</span>
                    </li>
                    <li className="mb-4 text-dark font-weight-600">
                      <span className="d-block text-primary lh-1">A/c No.:</span>
                      <span className="text-dark">0195010190831</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>


            <div className="col-lg-8 col-xl-9 mt-1-9">
              <div className="ps-xl-5">
                <h2 className="h3 mb-3 font-weight-800 lh-1">
                  Appeal for Donation: Volunteer with Us
                </h2>
                <p className="wow fadeInUp" data-wow-delay="100ms">Our universal ideology and selfless work have drawn many international volunteers. Bente Hagelund from Denmark during her stint along with her daughter Lise developed a strong bond with the Shamayita Math and motivated many Danish people to volunteer with us. Anna Mia and Soren spent six months researching the impacts of education at Shamayita Convent School. A textile designer by profession, Eva also from Denmark, worked closely with rural women on hand embroidery and developed marketing linkages for their products in Denmark. Ryan Slyzuk, a Canadian, found the experience at the Math extremely peaceful during his numerous visits while teaching social science. Riberio, a Spaniard, based on the endorsement of her friend, volunteered with us. Between late December 2023 and early March 2024, Signe and her husband Bjorn from Denmark spent time volunteering at the Math along with their sons Balder (11 years), Tobbert (8 years), and daughter Magnolia (6 years).
                </p>
                <p className="mb-2-2 wow fadeInUp" data-wow-delay="100ms">Be a part of our volunteer work and create your own story of your contribution toward those who need your time and skills to advance in their lives.
                </p>

                <h2 className="h3 mb-3 font-weight-800 lh-1">Join Us:</h2>
                <p className="wow fadeInUp" data-wow-delay="100ms">We are always looking for qualified and skillful professionals including technical experts, consultants, and resource persons to join our team and work for the effective implementation and management of various development projects.
                </p>
                <p className="wow fadeInUp" data-wow-delay="100ms">The selection process is rigorous comprising written tests, group discussions, and personal interviews. A major requirement is to possess a strong desire to work with rural communities and a willingness to embrace our vision and objectives. The selected candidates are provided a comprehensive orientation, which allows them to immerse in the work ethics, environment, and culture of the organization. Simultaneously, they are guided and mentored by senior professionals to further hone their capabilities.
                </p>
							  <p className="mb-2-2 wow fadeInUp font-weight-700 text-dark" data-wow-delay="100ms">Join us to become a part of a dedicated team and work together to bring about lasting development impacts for our communities. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="pt-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="bg-light p-1-9 p-md-5 border-radius-10">
                <h3 className="h4 border-bottom border-color-extra-light-gray mb-4 pb-3">
                  Contribute:
                </h3>
                <form className="contact" method="post">
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <label htmlFor="name">
                        Your Name <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Your name here"
                        required
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="email">
                        Your Email <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="email"
                        type="email"
                        name="email"
                        placeholder="Your email here"
                        required
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="phone">
                        Contact Number <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        id="phone"
                        type="tel"
                        name="phone"
                        placeholder="Your phone here"
                        required
                      />
                    </div>

                    <div className="col-md-6 form-group">
                      <label htmlFor="amount">Donation Amount</label>
                      <input
                        className="form-control"
                        id="amount"
                        type="text"
                        name="amount"
                        placeholder="Your amount here"
                      />
                    </div>

                    <div className="col-md-12 form-group">
                      <label htmlFor="message">
                        Message <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        rows="3"
                        placeholder="Tell us a few words"
                        required
                      ></textarea>
                    </div>

                    <div className="col-md-12 form-group">
                      <label htmlFor="captcha">Type the word below</label>
                      <input
                        className="form-control"
                        id="captcha"
                        type="text"
                        name="captcha"
                        placeholder="Type the below word"
                      />
                      <div className="mt-2">
                        <img
                          src="quform/images/captcha/courier-new-light.png"
                          alt="captcha"
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <button className="btn-style3 border-0" type="submit">
                        <span>Send</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
}

export default Donate;
